import { render, staticRenderFns } from "./AllEatDescBox.vue?vue&type=template&id=eff1fa14&scoped=true&"
import script from "./AllEatDescBox.vue?vue&type=script&lang=js&"
export * from "./AllEatDescBox.vue?vue&type=script&lang=js&"
import style0 from "./AllEatDescBox.vue?vue&type=style&index=0&id=eff1fa14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff1fa14",
  null
  
)

export default component.exports